export const ANALYTICS_EVENTS = Object.freeze({
    // Create new Company/Location
    TRIGGER_COMPANY_CREATION_FLOW_BS_ADMIN_VIEW: {
        name: "Trigger Company creation Flow (Betterspace Admin)",
        description: "Unternehmen erstellen Flow wurde gestartet",
    },
    TRIGGER_LOCATION_CREATION_FLOW_BS_ADMIN_VIEW: {
        name: "Trigger Location creation Flow (Betterspace Admin View)",
        description:
            "Location erstellen Flow wurde gestartet über die Betterspace Admin Ansicht",
    },
    TRIGGER_LOCATION_CREATION_FLOW_COMPANY_VIEW: {
        name: "Trigger Location creation Flow (Company View)",
        description:
            "Location erstellen Flow wurde gestartet über die Unternehmens Ansicht",
    },
    START_LOCATION_SETUP: {
        name: "Start the Location Set Up",
        description: "Die Location Details wurden spezifiziert",
    },
    ADD_SPACE_VIA_CSV_UPLOAD: {
        name: "Add a Space via CSV Upload",
        description: "Eine Liste mit Räumen wurde hochgeladen",
    },
    ADD_SPACE_MANUALLY: {
        name: "Add a Space via Manual adding",
        description: "Ein Raum wurde manuell hinzugefügt",
    },
    SET_UP_SPACE_PURPOSES: {
        name: "Set up the Space Purposes",
        description: "Raum-Zwecke wurden definiert",
    },
    ALLOCATE_SPACES_TO_SPACE_PURPOSE: {
        name: "Allocate Spaces to Space Purpose",
        description: "Räume wurden den Raumzwecken zugewiesen",
    },
    FINALIZE_LOCATION_SET_UP: {
        name: "Finalize the Location Set Up",
        description: "Das Aufsetzten der Location wurde abgeschlossen",
    },

    //  Set up Spaces/Subspaces
    EDITING_SPACES: {
        name: "Editing Spaces",
        description: "Der Space wurde bearbeitet",
    },
    GROUPING_SPACES: {
        name: "Grouping Spaces",
        description: "Spaces wurden gruppiert",
    },
    DELETE_SPACES: {
        name: "Delete Spaces",
        description: "Spaces wurden gelöscht",
    },
    ADD_SPACES: {
        name: "Add Spaces",
        description: "Neuer Space/Spaces wurde hinzugefügt",
    },

    // Login Completed
    SUCCESSFUL_LOGIN: {
        name: "Successful Login",
        description: "Erfolgreicher Login in die Plattform",
    },

    // User Management
    ADD_USER: {
        name: "Add User",
        description: "Erfolgreiches anlegen eines Nutzers",
    },
    DELETE_USER: {
        name: "Delete User",
        description: "Löschen eines Nutzers",
    },
    REMOVE_USER: {
        name: "Remove User",
        description: "Entfernen eines Nuzters",
    },
    EDIT_USER: {
        name: "Edit User",
        description: "Nutzer bearbeiten",
    },
    RESEND_USER_INVITATION: {
        name: "Resend User Invitation",
        description: "Einladung nochmals senden",
    },
    SEND_USER_AGENT: {
        name: "Track device and browser information",
        description: "Track device and browser information",
    },

    // Set Up Devices
    BULK_UPLOAD_DEVICES: {
        name: "Bulk Upload Devices",
        description: "Bulk Upload von Geräten",
    },
    DELETE_DEVICES: {
        name: "Delete Devices",
        description: "Löschen von Geräten",
    },
    ADD_DEVICES_MANUALLY_START: {
        name: "Add Devices Manually Start",
        description: "Starten des manuellen Geräte hinzufügens",
    },
    ADD_DEVICES_MANUALLY_END: {
        name: "Finish Manual Device Set Up",
        description: "Manuell Geräte hinzufügen abgeschlossen",
    },
    ASSIGN_DEVICE: {
        name: "Assign to Spaces/Subspaces",
        description: "Geräte zu einem Space/Subspace hinzufügen",
    },
    RETURN_DEVICES: {
        name: "Return Devices",
        description: "Zurückgeben des Gerätes ausgelöst",
    },
    UNDO_RETURN: {
        name: "Delete Return",
        description: "Rückgabe zurückgenommen",
    },

    // Set Up Occupancies
    ADD_OCCUPANCY_START: {
        name: "Start Add new Occupancy",
        description: "Starten Anlegen von Belegungen",
    },
    ADD_OCCUPANCY_END: {
        name: "End Add new Occupancy",
        description: "Abschließen Anlegen von Belegungen",
    },
    EDIT_OCCUPANCY: {
        name: "Edit Occupancy",
        description: "Beabreiten von Belegungen",
    },
    DELETE_OCCUPANCY: {
        name: "Delete Occupancy",
        description: "Löschen von Belegungen",
    },

    // Set Up Energy
    LOCK_TEMPERATURE_SETTINGS: {
        name: "Locking Temperature Settings",
        description: "Sperren/Freigeben der Temperatureinstellungen",
    },
    QUICK_ASSIGN_RULESET: {
        name: "Quick Assign Ruleset",
        description: "Schnelles Zuweisen des Regelsets",
    },
    EDIT_RULESET: {
        name: "Edit Ruleset",
        description: "Bearbeiten eines Regelsets",
    },
    DELETE_RULESET: {
        name: "Delete Ruleset",
        description: "Löschen eines Regelsets",
    },
    CREATE_RULESET: {
        name: "Create new Ruleset",
        description: "Anlegen eines neuen Regelsets",
    },
    COPY_RULESET: {
        name: "Copy Ruleset",
        description: "Kopieren eines Regelsets",
    },
    CREATE_RULE: {
        name: "Create new Rule",
        description: "Anlegen einer neuen Regel innerhalb eines Regelsets",
    },
    EDIT_RULE_START: {
        name: "Edit Rule",
        description: "Starten des Bearbeitens einer Regel",
    },
    EDIT_RULE_END: {
        name: "Finish Edit Rule",
        description: "Regel speichern/updaten",
    },
    DELETE_RULE: {
        name: "Delete Rule",
        description: "Löschen einer Regel innerhalb eines Regelsets",
    },
    ASSIGN_RULESET: {
        name: "Assign Ruleset",
        description: "Zuweisung eines Regelsets zu einem Space/Subspace",
    },

    // Energy Control Panel
    OPEN_TEMPERATURE_GRAPH: {
        name: "Open the Temperature Graph",
        description: "Aufrufen des Temperaturgraphen",
    },
    NAVIGATE_TO_RULESET: {
        name: "Navigate to Ruleset",
        description: "Aufrufen der Regelsets über das Energy Control Panel",
    },
    CHANGE_DESIRED_TEMPERATURE: {
        name: "Change Desired Temperature",
        description: "Ändern der Wunschtemperatur über das Controlpanel",
    },
    OPEN_CHANGE_LOG: {
        name: "Open the Change Log",
        description: "Aufrufen des Change Logs",
    },

    // Need of Help
    NAVIGATE_TO_HELP_CENTER: {
        name: "Navigate to Help Center",
        description: "Aufrufen des Helpcenters",
    },
} as const);
